import * as React from 'react';
import { Modal, ModalSize, ModalBody, HiddenInput, CheckboxList, Textarea, ModalFooter, CustomButton, CustomSubmitButton, ButtonType } from 'soprasteria-ui-library';
import { useAuth } from '../../../../App';
import { OrthodonticReferralResponseApi } from '../../../../api/OrthodonticReferralResponseApi';
import { ICheckbox } from 'soprasteria-ui-library/dist/models/IFormInput';
import { IOrthodonticReferralCompletion } from '../../../../models/IOrthodonticReferral';

interface IOrthodonticReferralRequestCompletionModal {
    orthodonticReferralId: number;
    renderForm: boolean;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
    onFormClose: () => void;
}

export const OrthodonticReferralRequestCompletionModal: React.FunctionComponent<IOrthodonticReferralRequestCompletionModal> = ({ orthodonticReferralId, renderForm, changeSuccessMessage, changeErrorMessage, getOrthodonticReferral, onFormClose }) => {
    const abortController = new AbortController();
    const auth = useAuth();
    const api = new OrthodonticReferralResponseApi(auth);
    const [isRequestingCompletion, setIsRequestingCompletion] = React.useState<boolean>(false);
    const [orthodonticReferralCompletionReasons, setOrthodonticReferralCompletionReasons] = React.useState<ICheckbox[]>();

    React.useEffect(() => {
        getOrthodonticReferralCompletionReasons();

        return () => {
            abortController.abort();
        }
    }, [])

    const requestCompletion = (data: IOrthodonticReferralCompletion) => {
        setIsRequestingCompletion(true);
        api.requestCompletion(data,
            () => {
                document.getElementById("close-request-completion-orthodontic-referral-modal")?.click();
                getOrthodonticReferral(orthodonticReferralId);
                changeSuccessMessage("Begäran om komplettering har skickats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsRequestingCompletion(false);
            })
    }

    const getOrthodonticReferralCompletionReasons = () => {
        api.getOrthodonticReferralCompletionReasons((data) => {
            const reasons = data.map<ICheckbox>((reason) => { return { label: reason.description, value: reason.orthodonticReferralCompletionReasonId.toString(), name: "orthodonticReferralCompletionReasonIds" } });
            setOrthodonticReferralCompletionReasons(reasons);
        });
    }

    return (
        <Modal header="Begär komplettering" id="request-completion-orthodontic-referral-modal" modalSize={ModalSize.large}>
            {
                renderForm ?
                    <>
                        <ModalBody>
                            <HiddenInput name="orthodonticReferralId" value={orthodonticReferralId.toString()} />
                            {
                                orthodonticReferralCompletionReasons ?
                                    <>
                                        <h6>Kompletteringsbegäran</h6>
                                        <div className="row">
                                            <div className="col-6">
                                                <CheckboxList name="orthodonticReferralCompletionReasonIds" initialCheckboxes={orthodonticReferralCompletionReasons.slice(0, Math.ceil(orthodonticReferralCompletionReasons.length / 2))} labelCol={8} inputCol={4} />
                                            </div>
                                            <div className="col-6">
                                                <CheckboxList name="orthodonticReferralCompletionReasonIds" initialCheckboxes={orthodonticReferralCompletionReasons.slice(Math.ceil(orthodonticReferralCompletionReasons.length / 2), orthodonticReferralCompletionReasons.length)} labelCol={8} inputCol={4} />
                                            </div>
                                        </div>
                                    </>
                                    : null
                            }
                            <Textarea name="comment" label="Kommentar" className="mt-3" required inlineLabel />
                        </ModalBody>
                        <ModalFooter>
                            <CustomButton buttonType={ButtonType.general} buttonText="Avbryt" data-dismiss="modal" id="close-request-completion-orthodontic-referral-modal" onClick={() => onFormClose()} />
                            <CustomSubmitButton isLoading={isRequestingCompletion} onButtonSubmit={requestCompletion} >Skicka</CustomSubmitButton>
                        </ModalFooter>
                    </>
                    : null
            }
        </Modal>
        )
}